import styled, { css } from "styled-components";
import { DARK_GRAY, LIGHT_BLUE, LIGHT_GRAY, LOW_BLUE, NEAR_WHITE } from "../../config";

const Button = styled.button.attrs({ "data-testid": "button" })`
  display: flex;
  align-items: center;
  outline: none;
  text-align: center;
  cursor: pointer;
  transition: 0.2s ease;
  white-space: nowrap;
  justify-content: center;
  border-radius: 8px;
  gap: 6px;

  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-transform: capitalize;
`;

export const PrimaryButton = styled(Button)`
  background: ${LIGHT_BLUE};
  color: ${NEAR_WHITE};
  border: 1px ${LIGHT_BLUE} solid;
  width: fit-content;
  padding: 10px 30px;

  ${({ disabled }) =>
    disabled
      ? css`
          background-color: ${DARK_GRAY};
          color: ${LIGHT_GRAY};
          cursor: not-allowed;
          border: 1px ${LIGHT_GRAY} solid;
        `
      : css`
          &:hover {
            background: ${LOW_BLUE};
          }
        `}
  &:active {
    background: ${LIGHT_BLUE};
  }
`;

export const SecondaryButton = styled(Button) <{ borderWidth?: number; color?: string }>`
  width: fit-content;
  color: ${({ color }) => color || LIGHT_BLUE};
  border: ${({ borderWidth, color }) => `${borderWidth ?? 1}px ${color || LIGHT_BLUE} solid`};
  background: transparent;
  padding: 10px 30px;

  ${({ disabled, color }) => {
    const hoverColor = color ? `${color}99` : LOW_BLUE;

    return disabled
      ? css`
          border-color: ${LIGHT_GRAY};
          color: ${LIGHT_GRAY};
          cursor: not-allowed;
        `
      : css`
          &:hover {
            border-color: ${hoverColor};
            color: ${hoverColor};
          }
        `;
  }}
  &:active {
    border-color: ${LIGHT_GRAY};
    color: ${LIGHT_GRAY};
  }
`;

export const SecondaryButtonAlt = styled(SecondaryButton)`
  border-width: 1px;
  border-radius: 6px;
  font-size: 12px;
  text-transform: none;
  font-weight: normal;
  padding: 8px 12px;
  white-space: nowrap;
`;

export const LinkButton = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  height: fit-content;
  padding: 5px 25px 5px 25px;
  text-align: center;
  white-space: nowrap;

  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  text-decoration: none;

  cursor: pointer;
  transition: 0.2s ease;

  color: ${LIGHT_GRAY};
  background: transparent;

  border: 1px ${LIGHT_GRAY} solid;
  border-radius: 4px;
  border-width: 1px;
  border-radius: 6px;

  &:hover {
    color: ${LOW_BLUE};
    border: 1px ${LOW_BLUE} solid;
  }

  svg {
    margin-left: 8px;
  }
`;

export const LargeButton = { width: "150px", margin: "12px" };

export const TextAction = styled(Button)`
  background: transparent;
  border: none;
  color: ${LIGHT_BLUE};
`;

export default Button;
